import React from 'react'

function initialiesLocalStorage<T>(key: string, initialValue: T): T {
  if (typeof window !== 'undefined') {
    const item = window.localStorage.getItem(key)
    if (item) {
      return JSON.parse(item)
    }
    window.localStorage.setItem(key, JSON.stringify(initialValue))
    return initialValue
  }
  return initialValue
}

export function useLocalStorage<T>(key: string, initialValue: T = {} as T): T {
  const [storageItem, setStorageItem] = React.useState<T>(() =>
    initialiesLocalStorage(key, initialValue)
  )

  React.useEffect(() => {
    const item = window.localStorage.getItem(key)
    if (item) {
      setStorageItem(JSON.parse(item))
    }
  }, [key])

  return storageItem || ({} as T)
}
